import {
  useLocation, Link,
} from 'react-router-dom';
import { VIEW_MODE } from 'store/shared/fixtures';
import { Paragraph } from 'library/styles/text';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { setViewMode } from 'store/shared/actions';
import { getViewMode } from 'store/shared/selectors';
import {
  Container,
  List,
  ListItem,
  Icon,
} from './styles';

const BrowsingMode = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const mode = useSelector(getViewMode);
  const stateRef = useRef(null);

  useEffect(() => {
    if (!location.pathname.includes(mode) && !stateRef.current) {
      stateRef.current = true;

      if (location.pathname.includes(VIEW_MODE.LIST)) {
        dispatch(setViewMode(VIEW_MODE.LIST));
      } else if (location.pathname.includes(VIEW_MODE.GRID)) {
        dispatch(setViewMode(VIEW_MODE.GRID));
      } else if (location.pathname.includes(VIEW_MODE.TABLE)) {
        dispatch(setViewMode(VIEW_MODE.TABLE));
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.includes(mode) && stateRef.current) {
      stateRef.current = false;
    }
  }, [mode, location.pathname]);

  return (
    <Container>
      <Paragraph>Browsing mode:</Paragraph>
      <List>
        <ListItem isActive={mode === VIEW_MODE.GRID}>
          <Link to={location.pathname.replace(mode, `${VIEW_MODE.GRID}`)}>
            <Icon className="icon-grid" />
          </Link>
        </ListItem>
        <ListItem isActive={mode === VIEW_MODE.LIST}>
          <Link to={location.pathname.replace(`${mode}`, `${VIEW_MODE.LIST}`)}>
            <Icon className="icon-list" />
          </Link>
        </ListItem>
        <ListItem isActive={mode === VIEW_MODE.TABLE}>
          <Link to={location.pathname.replace(`${mode}`, `${VIEW_MODE.TABLE}`)}>
            <Icon className="icon-table" />
          </Link>
        </ListItem>
      </List>
    </Container>
  );
};

export default BrowsingMode;
